module.exports = __webpack_public_path__ + "static/11-50663a4b85b86d224f4134110abc6bdc.jpg";